import { cva } from 'class-variance-authority';

export const cvaPaymentBox = cva([
  'PaymentBoxStyles-cvaPaymentBox',
  'sticky z-[120] w-[calc(100vw-4.8rem)] h-10',
  'bg-[#070417]',
]);

export const cvaPaymentBoxInner = cva(
  [
    'PaymentBoxStyles-cvaPaymentBoxInner',
    'bg-cDarkGray rounded-[0.8rem] -mt-2.4',
    'shadow-[0px_-5px_12.3px_0px_#00000059]',
  ],
  {
    variants: {
      padding: {
        all: ['py-2 px-2.4'],
        nonR: ['py-2 pl-2.4'],
      },
    },
  }
);
